<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <dashboard-panel></dashboard-panel>
    </b-col>
</template>

<script>
    import DashboardPanel from './dashboard/DashboardPanel.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'

    export default {
        components: { DashboardPanel , FuturocoinsFromMining },
    }
</script>

<style lang="scss">
    @media(max-width: 991px){
        .section-main{
            /*padding: 0;*/
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/DashboardContent.vue